import { datadogRum } from '@datadog/browser-rum';
import { objectInsertIf } from 'utils/insertIf';
import { onConsentChange } from 'utils/consent';

export const pageview = (url) => {
  if (window.gtag) {
    window.gtag('config', process.env.NEXT_PUBLIC_GA4_ID, {
      page_path: url,
    });
  }
};

const gaEvent = ({ action, category, label, value }) => {
  if (window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value,
    });
  }
};

export const GA_ACTIONS = {
  ADDRESS_ENTERED_CALCULATOR: 'AddressEnteredCalculator',
  ADDRESS_ENTERED_LANDING_PAGE_COVER: 'AddressEnteredLandingPageCover',
  ADDRESS_ENTERED_SIGNUP_FLOW: 'AddressEnteredSignUpFlow',
  LEAD_CREATED_CALCULATOR: 'LeadCreatedCalculator',
  LEAD_CREATED_SIGNUP_FLOW: 'LeadCreatedSignUpFlow',
  LEAD_CREATED_TRY_THE_PROS: 'LeadCreatedTryThePros',
};

const ACTIONS_MAP = {
  LeadCreatedCalculator: 'calculator',
  LeadCreatedSignUpFlow: 'sign_up_flow',
  LeadCreatedTryThePros: 'ask_a_question',
};

export const setEnhancedConvertionData = (user = {}) => {
  const enhancedConversionUser = {};
  if (user.email) enhancedConversionUser.email = user.email;
  if (user.phone) enhancedConversionUser.phone_number = user.phone;
  if (user.firstName) enhancedConversionUser.first_name = user.firstName;
  if (user.lastName) enhancedConversionUser.last_name = user.lastName;
  if (user.zipcode) enhancedConversionUser.postal_code = user.zipcode;
  if (user.country) enhancedConversionUser.country = user.country;

  let pushed = false;

  onConsentChange('marketing', (granted) => {
    if (granted && !pushed) {
      pushed = true;
      window.dataLayer?.push?.(enhancedConversionUser);
    }
  });
};

export const trackHomeownerAddressEntered = (action, address, rent) => {
  if (!action || !address?.city) {
    return;
  }

  gaEvent({
    category: 'Homeowner',
    action,
    label: `Rent|${address.city.replace(/ /g, '')}-${address.state.toUpperCase()}|${address.zipcode}`,
    ...objectInsertIf(rent?.estimate, {
      value: parseInt(rent?.estimate, 10),
    }),
  });
};

export const trackHomeownerLeadCreated = ({
  action,
  address,
  rent,
  coverageType,
  region,
}) => {
  if (!action) {
    return;
  }

  const leadCreatedEvent = { event_category: 'Homeowner' };
  const datadogAndMixPanelLeadEvent = { type: ACTIONS_MAP[action] };

  if (address?.streetAddress) {
    datadogAndMixPanelLeadEvent.streetAddress = address.streetAddress;
  }

  if (address?.city) {
    leadCreatedEvent.event_label = `Rent|${address.city.replace(/ /g, '')}-${address.state.toUpperCase()}|${
      address.zipcode
    }`;

    datadogAndMixPanelLeadEvent.city = address.city;
  }

  if (rent?.estimate) {
    leadCreatedEvent.value = parseInt(rent.estimate, 10);

    datadogAndMixPanelLeadEvent.rentEstimate = rent?.estimate;
  }

  if (coverageType) {
    leadCreatedEvent.coverage_type = coverageType;
    datadogAndMixPanelLeadEvent.coverage_type = coverageType;
  }

  if (region) {
    datadogAndMixPanelLeadEvent.region = region;
  }

  try {
    // TODO: Find a better way to structure this.
    if (window.mixpanel) {
      window.mixpanel.track('lead_created', datadogAndMixPanelLeadEvent);
    }

    datadogRum.addAction('lead_created', datadogAndMixPanelLeadEvent);

    if (action !== GA_ACTIONS.LEAD_CREATED_SIGNUP_FLOW) {
      gaEvent({
        category: 'Homeowner',
        action,
        ...objectInsertIf(address?.city, {
          label: `Rent|${address?.city.replace(/ /g, '')}-${address?.state.toUpperCase()}|${address?.zipcode}`,
        }),
        ...objectInsertIf(rent?.estimate, {
          value: parseInt(rent?.estimate, 10),
        }),
      });
    }

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: action,
      ...leadCreatedEvent,
    });
  } catch (e) {
    console.log(e);
  }
};
